var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.20312V10.2422C10.5 10.4871 10.3031 10.6875 10.0625 10.6875H3.9375C3.69687 10.6875 3.5 10.4871 3.5 10.2422V9.20312C3.5 8.9582 3.69687 8.75781 3.9375 8.75781H10.0625C10.3031 8.75781 10.5 8.9582 10.5 9.20312ZM10.0625 11.875H3.9375C3.69687 11.875 3.5 12.0754 3.5 12.3203V13.3594C3.5 13.6043 3.69687 13.8047 3.9375 13.8047H10.0625C10.3031 13.8047 10.5 13.6043 10.5 13.3594V12.3203C10.5 12.0754 10.3031 11.875 10.0625 11.875ZM14 4.89473V17.2188C14 18.2021 13.2161 19 12.25 19H1.75C0.783854 19 0 18.2021 0 17.2188V1.78125C0 0.797852 0.783854 0 1.75 0H9.19115C9.65417 0 10.099 0.189258 10.4271 0.523242L13.4859 3.63672C13.8141 3.96699 14 4.42344 14 4.89473ZM9.33333 1.92598V4.75H12.1078L9.33333 1.92598ZM12.25 17.2188V6.53125H8.45833C7.97344 6.53125 7.58333 6.13418 7.58333 5.64062V1.78125H1.75V17.2188H12.25Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e646e889.svg";
export { ForwardRef as ReactComponent };